export default __webpack_public_path__ + "static/media/hm-isb-img.ecf5e5fb.webp";